export const toQuickOrder = `/customer/quick-order`
